"use client";

import { CustomSelect } from "@/components/shared/formElements/CustomSelect";
import {
  PublicListingFilterField,
  PublicListingFiltersModal,
} from "@/views/shared/public-listing";

export interface TeachersPublicFiltersDraft {
  location: string | null;
}

export const EMPTY_TEACHERS_PUBLIC_FILTERS_DRAFT: TeachersPublicFiltersDraft = {
  location: null,
};

export function countTeachersPublicFilters(
  filters: TeachersPublicFiltersDraft,
): number {
  return filters.location ? 1 : 0;
}

export function TeachersPublicFiltersModal({
  isOpen,
  onClose,
  draft,
  onDraftChange,
  onApply,
  onClearDraft,
  locationOptions,
}: {
  isOpen: boolean;
  onClose: () => void;
  draft: TeachersPublicFiltersDraft;
  onDraftChange: (next: TeachersPublicFiltersDraft) => void;
  onApply: () => void;
  onClearDraft: () => void;
  locationOptions: string[];
}) {
  return (
    <PublicListingFiltersModal
      isOpen={isOpen}
      onClose={onClose}
      title="Filter instructors"
      onApply={onApply}
      onClearDraft={onClearDraft}
      hasDraftCriteria={countTeachersPublicFilters(draft) > 0}
      testId="teachers-public-filters-modal"
      applyTestId="teachers-public-filters-apply"
    >
      {locationOptions.length > 1 ? (
        <PublicListingFilterField label="Location">
          <CustomSelect
            placeholder="All locations"
            value={draft.location ?? ""}
            onChange={(val) =>
              onDraftChange({ location: val === "" ? null : val })
            }
            options={[
              { label: "All locations", value: "" },
              ...locationOptions.map((location) => ({
                label: location,
                value: location,
              })),
            ]}
          />
        </PublicListingFilterField>
      ) : null}
    </PublicListingFiltersModal>
  );
}
